
import React, { useEffect, useState, useRef, useCallback } from "react";
import cn from "classnames";
import styles from "../../components/battery/Battery.module.scss"
import SwapListing from '../../components/Reports/swapListing'
import RevenueListing from "../../components/Reports/revenueListing";
import RegisterListing from "../../components/Reports/RegisterListing";
import BatteryFaultListing from "../../components/Reports/BatteryFaultListing";
import { getRequest, postRequest } from "services/axiosBaseClient";
import PrintIcon from '@material-ui/icons/Print'
import MaterialTable from "@material-table/core";
import jsPDF from 'jspdf'
import 'jspdf-autotable'



 export default function List(props) {

  const [userRole, setUserRole] = useState("");
  const [navigation, setNavigation] = useState(false);
  const [swap,setSwap ] = useState([]);
  const [open, setOpen] = React.useState(false);
  const refOpen = useRef(open);
  const [state, setState] = React.useState({
    checkedB: true,
  });

  

  const getSwapList = useCallback(async () => {
    await getRequest("bss/reportsSwapListing")
      .then((res) => {
        if (res && res?.data) {
          setSwap(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);
  useEffect(() => {
    getSwapList();
  }, []);

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  function useOutsideAlerter(ref, ref1) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          refOpen.current = false;
        } else {
          if (
            refOpen.current &&
            ref1.current &&
            !ref1.current.contains(event.target)
          ) {
            refOpen.current = false;
            setOpen(false);
          } else {
            setOpen(true);
            refOpen.current = true;
          }
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, ref1]);
  }

  const wrapperRef = useRef(null);
  const wrapperRefInside = useRef(null);

  useOutsideAlerter(wrapperRef, wrapperRefInside);

  const handleClick = () => {
    if (open) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const columns = [
    { title: "24Hrs", field: "hourCount", },
    { title: "1Week", field: "weekCount", },
    { title: "1Month", field: "monthCount", type: "numeric" },
    { title: "3Month", field: 'quarterCount', }]

  const downloadPdf = () => {
    const doc = new jsPDF()
    doc.text("Student Details", 20, 10)
    doc.autoTable({
      theme: "grid",
      columns: columns.map(col => ({ ...col, dataKey: col.field })),
      body: swap
    })
    doc.save('table.pdf')
  }

  return (
    <>
    <div><SwapListing headerFilter={props.headerFilter}/> </div>
        <div><RevenueListing headerFilter={props.headerFilter}/></div>
        <div><RegisterListing headerFilter={props.headerFilter}/></div>
        <div><BatteryFaultListing headerFilter={props.headerFilter}/></div>
    </>
  );
}
















/*import React, { useState, useEffect, useRef,useCallback } from "react";
import cn from "classnames";
import styles from "../../components/battery/Battery.module.scss";
import Table from "../../components/common/Table";
import { getRequest, postRequest } from "services/axiosBaseClient";
import styled from "styled-components";

export default function List(props) {
  
  // const [open, setOpen] = React.useState(false);
  const [droppedFilter, setDroppedFilter] = useState(false);
  const [data,setSwap ] = useState([]);

  const getSwapList = useCallback(async () => {
    await getRequest("bss/reportsSwapListing")
      .then((res) => {
        if (res && res?.data) {
          setSwap(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);
  const columns = React.useMemo(()=> [
    {
      Header: "24 Hrs",
      selector: (row)=>row.hourCount,
    },
    {
      Header: "1 Week",
      accessor: "weekCount",
    },
    {
      Header: "1Month",
      accessor: "monthCount",
    },
    {
      Header: "3Months",
      accessor: "quarterCount",
    },
  ])

  useEffect(() => {
    getSwapList();
  }, []);

 /* var datas = [
    {
      hourCount: "10",
      weekCount: "100",
      monthCount: "3000",
      quarterCount: "12000",
    },
    
  ];*/

 /* return (
    <>
      <div className={cn(styles.alert,)}
        style={{
          backgroundColor: "rgb(252, 252, 252)",
          boxShadow: "0px 3px 8px 2px rgba(35, 41, 122, 0.24705882352941178)",
          borderRadius: "5px 5px 5px 5px",
          margin: "20px 3% 0 0.5%",
        }}
      >
         <h2 style={{padding:"25px"}} className={cn(styles.medium_title, styles.medium_title_layout)}>
        { "Swap Listing"}
      </h2>
          <Table columns={columns} data={data}  pagination={false}/>
      </div>
      <div style={{marginTop:"30px"}}>
      <div className={cn(styles.alert,)}
        style={{
          backgroundColor: "rgb(252, 252, 252)",
          boxShadow: "0px 3px 8px 2px rgba(35, 41, 122, 0.24705882352941178)",
          borderRadius: "5px 5px 5px 5px",
          margin: "20px 3% 0 0.5%",
        }}
      >
         <h2 style={{padding:"25px"}} className={cn(styles.medium_title, styles.medium_title_layout)}>
        { "Revenue Listing"}
      </h2>
          <Table columns={columns} data={data} />
      </div>
      </div>
      <div style={{marginTop:"30px"}}>
      <div className={cn(styles.alert,)}
        style={{
          backgroundColor: "rgb(252, 252, 252)",
          boxShadow: "0px 3px 8px 2px rgba(35, 41, 122, 0.24705882352941178)",
          borderRadius: "5px 5px 5px 5px",
          margin: "20px 3% 0 0.5%",
        }}
      >
         <h2 style={{padding:"25px"}} className={cn(styles.medium_title, styles.medium_title_layout)}>
        { "Register Listing"}
      </h2>
          <Table columns={columns} data={data}  />
      </div>
      </div>
      <div style={{marginTop:"30px"}}>
      <div className={cn(styles.alert,)}
        style={{
          backgroundColor: "rgb(252, 252, 252)",
          boxShadow: "0px 3px 8px 2px rgba(35, 41, 122, 0.24705882352941178)",
          borderRadius: "5px 5px 5px 5px",
          margin: "20px 3% 0 0.5%",
        }}
      >
         <h2 style={{padding:"25px"}} className={cn(styles.medium_title, styles.medium_title_layout)}>
        { "Battery Fault Listing"}
      </h2>
          <Table columns={columns} data={data} />
      </div>
      </div>
    </>
  );
}*/










/*import React, { useEffect, useState, useRef, useCallback } from "react";
import cn from "classnames";
import styles from "./report.module.scss"

//import RevenueListing from "../Listing/revenueListing";
//import RegisterListing from "../Listing/RegisterListing";
//import BatteryFaultListing from "../Listing/BatteryFaultListing";
import Tb from "../Listing/Tb";
import { getRequest, postRequest } from "services/axiosBaseClient";




 export default function List(props) {

  const [userRole, setUserRole] = useState("");
  const [navigation, setNavigation] = useState(false);
  const [open, setOpen] = React.useState(false);
  const refOpen = useRef(open);
  const [state, setState] = React.useState({
    checkedB: true,
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  function useOutsideAlerter(ref, ref1) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          refOpen.current = false;
        } else {
          if (
            refOpen.current &&
            ref1.current &&
            !ref1.current.contains(event.target)
          ) {
            refOpen.current = false;
            setOpen(false);
          } else {
            setOpen(true);
            refOpen.current = true;
          }
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, ref1]);
  }

  const wrapperRef = useRef(null);
  const wrapperRefInside = useRef(null);

  useOutsideAlerter(wrapperRef, wrapperRefInside);

  const handleClick = () => {
    if (open) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  

  return (
    <>
      <h2  className={cn(styles.medium_title, styles.medium_title_layout)}>
        {userRole.toLowerCase() === "admin"
          ? "Admin Dashboard"
          : "Reports"}
      </h2>
       
        <div> <Tb/></div>
    </>
  );
}*/

